import * as ambassadorWixMultilingualMachineV1CreditData from './multilingual-machine-v1-credit-data-translation-credits.http.js';
import * as ambassadorWixMultilingualMachineV1CreditDataTypes from './multilingual-machine-v1-credit-data-translation-credits.types.js';
import * as ambassadorWixMultilingualMachineV1CreditDataUniversalTypes from './multilingual-machine-v1-credit-data-translation-credits.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getCreditData(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMultilingualMachineV1CreditDataUniversalTypes.GetCreditDataRequest,
  ambassadorWixMultilingualMachineV1CreditDataTypes.GetCreditDataRequest,
  ambassadorWixMultilingualMachineV1CreditDataUniversalTypes.GetCreditDataResponse,
  ambassadorWixMultilingualMachineV1CreditDataTypes.GetCreditDataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualMachineV1CreditData.getCreditData(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/credit',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function checkSufficientCredits(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualMachineV1CreditDataUniversalTypes.CheckSufficientCreditsRequest,
  ambassadorWixMultilingualMachineV1CreditDataTypes.CheckSufficientCreditsRequest,
  ambassadorWixMultilingualMachineV1CreditDataUniversalTypes.CheckSufficientCreditsResponse,
  ambassadorWixMultilingualMachineV1CreditDataTypes.CheckSufficientCreditsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualMachineV1CreditData.checkSufficientCredits(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/credit/is-eligible',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CreditData as CreditDataOriginal,
  CreditDataTypeOneOf as CreditDataTypeOneOfOriginal,
  Quota as QuotaOriginal,
  QuotaWithLiterals as QuotaWithLiteralsOriginal,
  LimitedQuota as LimitedQuotaOriginal,
  GetCreditDataRequest as GetCreditDataRequestOriginal,
  GetCreditDataResponse as GetCreditDataResponseOriginal,
  CheckSufficientCreditsRequest as CheckSufficientCreditsRequestOriginal,
  CheckSufficientCreditsResponse as CheckSufficientCreditsResponseOriginal,
  ReportCreditUsageRequest as ReportCreditUsageRequestOriginal,
  ReportCreditUsageResponse as ReportCreditUsageResponseOriginal,
  UpdateCreditRequest as UpdateCreditRequestOriginal,
  UpdateCreditResponse as UpdateCreditResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  CheckSufficientCreditsApplicationErrors as CheckSufficientCreditsApplicationErrorsOriginal,
} from './multilingual-machine-v1-credit-data-translation-credits.types.js';
